import React, { useState, createContext, useContext, useMemo } from "react";

const PlansContext = createContext(null);
export const usePlansContext = () => useContext(PlansContext);

export const PlansProvider = ({ children }) => {
  const [loadingSavingTime, setLoadingSavingTime] = useState(true);
  const [loadingReturnPercentage, setLoadingReturnPercentage] = useState(true);
  const [loadingQuote, setLoadingQuote] = useState(false);

  const isLoadingData = useMemo(() => {
    return loadingSavingTime || loadingReturnPercentage || loadingQuote;
  }, [loadingSavingTime, loadingReturnPercentage, loadingQuote]);

  const contextValue = {
    loadingSavingTime,
    loadingReturnPercentage,
    loadingQuote,
    isLoadingData,
    setLoadingSavingTime,
    setLoadingReturnPercentage,
    setLoadingQuote,
  };

  return (
    <PlansContext.Provider value={contextValue}>
      {children}
    </PlansContext.Provider>
  );
};
